<template>
  <div class="custom-viewcube-box">
    <el-dropdown
      placement="bottom-start"
      @command="setUserView"
      trigger="click"
      :append-to-body="false">
      <div title="视图设置">
        <icon-svg
          size="24"
          class="icon"
          icon-class="ic-a-SwitchViews" />
      </div>
      <el-dropdown-menu
        slot="dropdown"
        class="common-viewcube-dropdown-box">
        <el-dropdown-item command="1">
          <span>
            <icon-svg
              size="16"
              class="icon"
              icon-class="ic-a-Setasmainview" />
          </span>
          <span>设为主视图</span>
        </el-dropdown-item>
        <el-dropdown-item command="2">
          <span>
            <icon-svg
              size="16"
              class="icon"
              icon-class="ic-a-ResetHomeView" />
          </span>
          <span>重置主视图</span>
        </el-dropdown-item> </el-dropdown-menu
      >　
    </el-dropdown>
  </div>
</template>

<script>
import { setViewAngleService } from '@/service/interface'

export default {
  props: {
    definedType: Number
  },
  methods: {
    setUserView(command) {
      let projId = this.$route.params.projId
      let resourceId = ''
      if (this.definedType === 1) {
        resourceId = this.$route.query.datasetId
      } else {
        resourceId = this.$route.query.sceneId
      }
      let params = {
        definedType: this.definedType,
        projId,
        resourceId
      }
      let visualAngle = ''
      if (command === '1') {
        let viewAngle = this.getViewAngle()
        viewAngle = this.formatViewAngle(viewAngle)
        visualAngle = JSON.stringify(viewAngle)
      } else {
        this.setDefaultViewAngle()
        visualAngle = 'DefaultVisualAngle'
      }
      params.visualAngle = visualAngle
      setViewAngleService(params).then(response => {
        if (response.isSuccess) {
          if (command === '1') {
            this.$message.success('主视图设置成功')
          } else {
            this.$message.success('主视图已重置')
          }
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    setDefaultViewAngle() {
      window.BlackHole3D.Camera.setCamLocateDefault(
        window.BlackHole3D.RECamDirEm.CAM_DIR_TOPRIGHTBACK,
        true
      )
    },
    formatViewAngle(viewAngle) {
      let { camDir, camPos, camRotate } = viewAngle
      camDir = camDir.map(el => Number(el.toFixed(6)))
      camPos = camPos.map(el => Number(el.toFixed(6)))
      camRotate = camRotate.map(el => Number(el.toFixed(6)))
      return { camDir, camPos, camRotate }
    },
    getViewAngle() {
      return window.BlackHole3D.Camera.getCamLocate()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.custom-viewcube-box {
  position: absolute;
  top: 25px;
  right: 15px;

  .icon {
    font-size: 24px;
    cursor: pointer;

    :deep(.svg-icon) {
      color: var(--aside-bg-color);
    }
  }
}
</style>

<style lang="less">
.common-viewcube-dropdown-box {
  margin: 0px;
  padding: 0px;
  margin-top: 10px !important;
  background-color: var(--bimview-viewcube-bgColor) !important;
  border: 1px solid var(--bimview-viewcube-border-color) !important;

  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    line-height: 25px;
    color: var(--bimview-viewcube-menu-color);
    border-bottom: 1px solid transparent;

    .icon {
      font-size: 18px;
      margin-right: 5px;
    }

    &:last-of-type {
      border-bottom: none;
    }

    &:not(.is-disabled):hover {
      background-color: transparent;
      color: var(--bimview-viewcube-menu-hover-color);
    }
  }

  .popper__arrow {
    border-bottom-color: var(--bimview-viewcube-popper-arrow-color) !important;

    &::after {
      border-bottom-color: var(
        --bimview-viewcube-popper-arrow-color
      ) !important;
    }
  }
}
</style>
